import { useMemo } from 'react'
import { BulkAction, TableAction } from '../types-v4'

export function useSelectionEnabled(
  actions?: TableAction[],
  bulkActions?: BulkAction[]
) {
  const isSelectionEnabled = useMemo(() => {
    return (
      actions?.some((a) => a.requiresSelection) ||
      bulkActions?.some((a) => a.requiresSelection) ||
      false
    )
  }, [actions, bulkActions])

  return isSelectionEnabled
}

